export const userAction = user => ({
  type: 'USER',
  user,
})
